// This file is generated by pnpm icons:generate. Do not edit.

import {PinLocation_Stroke2_Corner0_Rounded as CanonicalPinLocation_Stroke2_Corner0_Rounded} from './Pin'

/** @deprecated Import PinLocation_Stroke2_Corner0_Rounded from `#/components/icons/Pin` instead. */
export const PinLocation_Stroke2_Corner0_Rounded =
  CanonicalPinLocation_Stroke2_Corner0_Rounded
